/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Online_Vs_TitleInputs */

const en_fc_online_vs_title = /** @type {(inputs: Fc_Online_Vs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online vs desktop`)
};

/**
* | output |
* | --- |
* | "Online vs desktop" |
*
* @param {Fc_Online_Vs_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_online_vs_title = /** @type {((inputs?: Fc_Online_Vs_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Online_Vs_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_online_vs_title(inputs)
});
export { fc_online_vs_title as "fc.online.vs.title" }